/* istanbul ignore file */
import {AspectRatioCard, AspectRatioCardImage} from '@homeaway/react-aspect-ratio-card';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import ListingPrice from './listing-price';
import ListingRooms from './listing-rooms';
import ListingUrl from './listing-url';
import React from 'react';
import './listing-mini-hit.less';

export const ASPECT_RATIO_4X3 = '4x3';

export function ListingMiniHit({
    aspectRatio = ASPECT_RATIO_4X3,
    averagePrice,
    bathrooms,
    bedrooms,
    className,
    detailPageUrl,
    edapEventJson,
    images,
    imageUri,
    isMobile,
    onClick,
    priceSummary,
    sleeps,
    status,
    stay,
    // pass translations props down <ListingPrice/> in case rendered inside Google Map Overlay
    langAvgNight,
    langDatesNotAvailable,
    langNoPrice
}) {
    if (!imageUri) {
        imageUri = Array.isArray(images) ? (images[0] && images[0].lowResSrc) || '' : '';
    }

    return (
        <ListingUrl
            className={`listing-mini-hit ${className || ''}`}
            detailPageUrl={detailPageUrl}
            onClick={onClick}
            stay={stay}
            target={isMobile ? '_self' : '_blank'}
        >
            <AspectRatioCard aspectRatio={aspectRatio}>
                <AspectRatioCardImage
                    data-slot={'figure'}
                    imageUri={imageUri}
                />
                <ListingRooms
                    bathrooms={bathrooms}
                    bedrooms={bedrooms}
                    className="AspectRatioCardTitle h4 text-bold text-ha-gray-dark"
                    data-slot={'caption'}
                    sleeps={sleeps}
                />
                <ListingPrice
                    averagePrice={averagePrice}
                    data-slot={'content'}
                    edapEventJson={edapEventJson}
                    langAvgNight={langAvgNight}
                    langDatesNotAvailable={langDatesNotAvailable}
                    langNoPrice={langNoPrice}
                    priceSummary={priceSummary}
                    stay={stay}
                    status={status}
                />
            </AspectRatioCard>
        </ListingUrl>
    );
}

export default determineIfMobile(ListingMiniHit);


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-mini-hit.js